import { useTranslation } from 'react-i18next'
import RefinedBrands from '../Brands/RefinedBrands'
import RefinedCategories from '../DeviceCategories/RefinedCategories'
import Price from '../Price/Price'
import CustomSortBy from '../DesktopSort/CustomSortBy'
import CustomClearRefinements from '../CurrentRefinement/ClearRefinements'
import CustomInfiniteHits from '../InfiniteHits/InfiniteHits'
import { getParameter } from '../../functions/getAlgoliaFilter'
import './DesktopComponent.scss'

const DesktopComponent = (currentRefinement: any) => {
  const { t } = useTranslation()
  const brandParam = getParameter("brand") !== null
  
  return (
    <div>
      <div className="devicesTitle">{t('devices')}</div>
      <RefinedCategories attribute="type" facetOrdering={true} />
      <CustomSortBy />
      <div className="homePage">
        <div className="left-panel" id="left-panel">
          <div className="big-left-filter-box">
            <div className="left-header">
              <span className="filter">{t('filter')}</span>
              <span className="reset">
                <CustomClearRefinements clearsQuery />
              </span>
            </div>
            <Price />
            {brandParam? <></> : <RefinedBrands attribute="DeviceManufacturer" />}
          </div>
        </div>
        <div className="right-panel">
          {currentRefinement !== '' ? (
            <>
              <CustomInfiniteHits />
            </>
          ) : null}
        </div>
      </div>
    </div>
  )
}

export default DesktopComponent
